import React, { useCallback, useLayoutEffect, useMemo, useState } from "react";
import style from "css/hotdesking.module.css";
import Search from "./Search";
import axios from "axios";
import HotdeskingConfig from "../Config";
import Content from "./Content";
import { ConfigProvider, Dialog } from "antd-mobile";
import koKR from "antd-mobile/es/locales/ko-KR";
import BookFloatingPanel from "./BookFloatingPanel";
import BookInfo from "./BookInfo";
import Error from "./Error";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

function Page() {
  //Modal State
  const [isInfo, setIsInfo] = useState(false);
  //Book State
  const [book, setBook] = useState(null);
  const [resource, setResource] = useState(null);
  const [findInfo, setFindInfo] = useState(null);
  //Refresh State
  const [initCanvas, setInitCanvas] = useState(false);
  const [isDepartmentFind, setIsDepartmentFind] = useState(false);
  const [isCanvasFind, setIsCanvasFind] = useState(false);
  const [isRefresh, setIsRefresh] = useState(false);
  //Date & Time State
  const [serverDate, setServerDate] = useState("");
  const [date, setDate] = useState(dayjs(new Date()).format("YYYY-MM-DD"));
  const [time, setTime] = useState({
    start: "00:00",
    end: "00:00",
  });
  const [workTime, setWorkTime] = useState({
    start: "",
    end: "",
  });
  //Department State
  const [departmentId, setDepartmentId] = useState(null);
  //Location State
  const [location, setLocation] = useState(null);
  //Canvas State
  const [bookList, setBookList] = useState([]);
  const [resourceList, setResourceList] = useState([]);

  const getWorkTime = useCallback(() => {
    axios
      .get(`${HotdeskingConfig.baseURI}/worktime`)
      .then((res) => {
        setTime({
          start: res.data.startTime,
          end: res.data.endTime,
        });
        setWorkTime({
          start: res.data.workStartTime,
          end: res.data.workEndTime,
        });
        setServerDate(res.data.currentDate);
        setInitCanvas(true);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const getBook = useCallback(() => {
    axios.get(`${HotdeskingConfig.baseURI}/book`).then((res) => {
      if (res.data === "") {
        setBook(null);
      } else {
        setBook(res.data);
      }
    });
  }, []);
  const getBookList = useCallback(() => {
    const config = {
      params: {
        location_id: location.id,
        start_dttm: date + " " + time.start,
        end_dttm: date + " " + time.end,
      },
    };
    axios.get(`${HotdeskingConfig.baseURI}/book/list`, config).then((res) => {
      setBookList(res.data);
    });
  }, [date, location, time.end, time.start]);
  const getResourseList = useCallback(() => {
    const config = {
      params: {
        location_id: location.id,
      },
    };
    axios
      .get(`${HotdeskingConfig.baseURI}/resource/list`, config)
      .then((res) => {
        setResourceList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [location]);

  const setDefaultLocation = useCallback((item) => {
    setDepartmentId(item.departmentId);
    setLocation(item);
    setIsDepartmentFind(true);
  }, []);

  useMemo(() => {
    getWorkTime();
  }, [getWorkTime]);
  useMemo(() => {
    getBook();
  }, [getBook]);

  //Canvas Initial Event
  useLayoutEffect(() => {
    if (initCanvas && location != null) {
      getBookList();
      getResourseList();
      setIsRefresh(true);
      setInitCanvas(false);
    }
  }, [getBookList, getResourseList, initCanvas, location]);

  //Change Location Event
  const onSelectLocation = (location) => {
    if (!location) {
      setLocation(null);
      setIsRefresh(true);
    } else {
      setLocation(location);
      setInitCanvas(true);
    }
    if (departmentId !== null) {
      setDepartmentId(null);
    }
  };

  const onCloseInfoModal = () => {
    setResource(null);
    setFindInfo(null);
    setIsInfo(false);
  };
  //자리 확인
  const onShowBook = (book, resource) => {
    setResource(resource);
    setFindInfo(book);
    setIsInfo(true);
  };
  //에러 팝업
  const onOpenError = (message) => {
    Dialog.show({
      className: `${style.dialog} ${style.alert}`,
      bodyClassName: `${style.dialog_body}`,
      bodyStyle: { padding: 0 },
      content: <Error message={message} />,
    });
  };
  //내 예약 정보 갱신
  const onRefreshBook = () => {
    getBook();
    setInitCanvas(true);
  };

  const onShowResource = (
    departmentId,
    departmentTitle,
    locationId,
    locationTitle,
    locationSource,
    resourceId,
    resourceTitle,
    resourceType,
    coordinateX,
    coordinateY
  ) => {
    setDepartmentId(departmentId);
    const location = {
      id: locationId,
      title: locationTitle,
      source: locationSource,
      departmentTitle: departmentTitle,
    };
    setLocation(location);
    setIsDepartmentFind(true);
    setResource({
      id: resourceId,
      title: resourceTitle,
      type: resourceType,
      coordinateX: coordinateX,
      coordinateY: coordinateY,
      location: location,
    });
    setIsCanvasFind(true);
  };

  return (
    <ConfigProvider locale={koKR}>
      <section className={style.wrapper}>
        <section className={style.container}>
          <Search
            date={date}
            setDate={setDate}
            time={time}
            setTime={setTime}
            location={location}
            setLocation={onSelectLocation}
            departmentId={departmentId}
            isFind={isDepartmentFind}
            setIsFind={setIsDepartmentFind}
            onShowBook={onShowBook}
            serverDate={serverDate}
            workTime={workTime}
            setDefaultLocation={setDefaultLocation}
          />
          <Content
            bookCnt={bookList.length}
            resourceCnt={resourceList.length}
            bookList={bookList}
            resourceList={resourceList}
            bookInfo={findInfo}
            isFind={isCanvasFind}
            setIsFind={setIsCanvasFind}
            location={location}
            isRefresh={isRefresh}
            setIsRefresh={setIsRefresh}
            onShowBook={onShowBook}
            onRefreshBook={onRefreshBook}
            onError={onOpenError}
            date={date}
            time={time}
            serverDate={serverDate}
            setTime={setTime}
            resource={resource}
            setResource={setResource}
          />
          <BookFloatingPanel
            book={book}
            serverDate={serverDate}
            date={date}
            time={time}
            setTime={setTime}
            onRefreshBook={onRefreshBook}
            onShowResource={onShowResource}
            onError={onOpenError}
            resource={resource}
            setResource={setResource}
          />
          <BookInfo
            book={findInfo}
            resource={resource}
            isOpen={isInfo}
            onClose={onCloseInfoModal}
          />
        </section>
      </section>
    </ConfigProvider>
  );
}

export default Page;
